module.exports = __webpack_public_path__ + "static/img/m1.bd8bf2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-neo/mobile/m1.png
// module id = bPMG
// module chunks = 12